var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 748,
    height: 909,
    viewBox: "0 0 748 909",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_536_5)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_536_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 455L749.613 105.992L749.613 804.008L15 455Z",
    fill: "#454545",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_536_5",
    x: 0.99198,
    y: 93.0612,
    width: 762.629,
    height: 726.033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07754
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.00401
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.376471 0 0 0 0 0 0 0 0 0 0.823529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_536_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_536_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_536_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 748,
    height: 909,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame5);
export default __webpack_public_path__ + "static/media/Frame 5.859a12766920df299b04404284e39940.svg";
export { ForwardRef as ReactComponent };